import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Form, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FlexibleTextArea } from 'UI/Inputs';
import { Spinner } from 'UI';
import { Button, Icon, Flex, translate } from '@haldor/ui';
var MessageForm = /*#__PURE__*/function (_Component) {
  function MessageForm(props) {
    var _this;
    _classCallCheck(this, MessageForm);
    _this = _callSuper(this, MessageForm, [props]);
    _defineProperty(_this, "submit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var conversation, data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setState({
                  hideInput: true
                });
              case 2:
                conversation = _this.props.conversation;
                data = _objectSpread({}, values);
                data.text = values.text + '';
                if (conversation != null) {
                  data.conversationID = conversation.id;
                }
                data.parentId = null;
                data.text = values.text.replace(/\n/g, "<br />");
                _context.next = 10;
                return _this.setState({
                  hideInput: false
                });
              case 10:
                if (_this.props.onSubmit) {
                  _this.props.onSubmit(data).then(function () {
                    _this.props.reset();
                    resolve(1);
                  });
                } else {
                  setTimeout(function () {
                    _this.props.reset();
                    resolve(1);
                  }, 1000);
                }
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_this, "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string
        return undefined;
      }

      // Field failed validation, return error for this field (String)
      return "Skriv ett meddelande";
    });
    _this.state = {
      hideInput: false
    };
    return _this;
  }
  _inherits(MessageForm, _Component);
  return _createClass(MessageForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        valid = _this$props.valid;
      var placeHolderText = this.props.translate('Send message');
      if (this.props.conversation != null) {
        if (this.props.conversation.status.toUpperCase() == "ARCHIVED") {
          placeHolderText = this.props.translate('Conversation is archived');
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation message-form"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, !this.state.hideInput ? /*#__PURE__*/React.createElement(Field, {
        component: FlexibleTextArea,
        type: "text",
        name: "text",
        placeholder: placeHolderText,
        validate: this.required,
        disabled: this.props.disabled,
        rows: 1
      }) : null), /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, !submitting ? /*#__PURE__*/React.createElement(Icon, {
        name: "Send"
      }) : null, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "loading-container"
      }, /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      })) : null))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(reduxForm({
  form: 'MessageForm',
  destroyOnUnmount: true
})(MessageForm));